import {jsonMember, jsonObject} from 'typedjson';

export enum TUPLA_TYPE {
  STRING,
  NUMBER,
  PERCENTAGE,
  LINK,
  BOOLEAN,
  DATETIME,
  UNDEFINED
}
export enum DATA_TYPE {
  Grid,
  Row,
  Tupla,
  TuplaDescription,
  SeriesHistorical,
  SeriesIntraday,
  SeriesFundHistorical,
  SeriesDividendCorrection,
  Grids,
  NewsList,
  News
}

export enum CHART_TYPE {
  LINEAR,
  SPLINE,
  CANDLESTICK,
  OHLC,
  AREA,
  COLUMN,
  PIE,
  PIE_COLUMNGROUP,    // Pie chart for each column
  COLUMNSTACK,
  BAR,
  STOCKLINEAR,
  STOCKAREA,
  STOCKAREASPLINE
}

@jsonObject
export class DataBase {
  @jsonMember
  private dataType: string;
  @jsonMember
  private language: string;
  @jsonMember
  private id: string;

  private subscribeId: string;

  get SubscribeId(): string {
    return this.subscribeId;
  }

  set SubscribeId(value: string) {
    this.subscribeId = value;
  }

  get DataType(): string {
    return this.dataType;
  }

  set DataType(value: string) {
    this.dataType = value;
  }

  get Language(): string {
    return this.language;
  }

  set Language(value: string) {
    this.language = value;
  }

  get Id(): string {
    return this.id === undefined ? ' ' : this.id;
  }

  set Id(value: string) {
    this.id = value;
  }
}
